export default __webpack_public_path__ + "static/media/water-budget.b02957dc.svg";